import { render, staticRenderFns } from "./PackageConfig.vue?vue&type=template&id=324dd27e&scoped=true"
import script from "./PackageConfig.vue?vue&type=script&lang=js"
export * from "./PackageConfig.vue?vue&type=script&lang=js"
import style0 from "./PackageConfig.vue?vue&type=style&index=0&id=324dd27e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324dd27e",
  null
  
)

export default component.exports